module.exports = __webpack_public_path__ + "assets/img/red.1280181e.png";